import { Component, OnInit, Input, Output, forwardRef, ViewChild, Optional, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel, NG_ASYNC_VALIDATORS, NG_VALIDATORS } from '@angular/forms';
import { ElementBase } from '../base/element-base';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent extends ElementBase<string> {

  @Input()
  title: string;

  @Input()
  type = 'text';

  @Input()
  readonly = false;

  @ViewChild(NgModel, {static: true}) model: NgModel;

  @ViewChild('inputControl', {static: true}) inputControl;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  public focusInput() {
    this.inputControl.nativeElement.focus();
  }

  valueChanged(value) {
    const isSpaceValue = value.length > 0 && value.trim().length === 0;
    if (isSpaceValue) {
      this.model.control.setValue('');
      return;
    }
  }

  trimValue(value) {
    this.model.control.setValue(this.model.value.trim());
  }
}
